import script from "./HighScores.vue?vue&type=script&setup=true&lang=js"
export * from "./HighScores.vue?vue&type=script&setup=true&lang=js"

import "./HighScores.vue?vue&type=style&index=0&id=6aa71f9b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa71f9b"]])

export default __exports__